/**
 * PaginationDots component.
 */
import PaginationDot from '@components/atoms/icons/paginationDot';
/**
 * Props for the PaginationDots component.
 */
export interface PaginationDotsProps {
  Container: React.ElementType;
  length: number;
  index: number;
}

/**
 * Renders the pagination dots list.
 */
export default function PaginationDots({
  Container,
  length,
  index,
}: PaginationDotsProps) {
  return length > 1 ? (
    <Container id={'paginationDots'}>
      {[...Array(length)]?.map((_, i) => (
        <PaginationDot focused={i === index} key={i} />
      ))}
    </Container>
  ) : null;
}
